import React from 'react';
import {
  majorScale,
  Button,
  Popover,
  Menu,
  Position,
  ColumnLayoutIcon,
  ChevronDownIcon,
} from 'evergreen-ui';
import PropTypes from 'prop-types';
import { searchParams as historySearchParams } from '../../../services/history';

const ColumnsMenu = ({ selectedColumns, setSelectedColumns }) => {
  const handleSelect = (columnName) => {
    const columns = selectedColumns.split(',');

    if (columns.includes(columnName)) {
      const idx = columns.indexOf(columnName);
      columns.splice(idx, 1);
    } else {
      columns.push(columnName);
    }

    const columnsString = columns.join(',');
    historySearchParams.set('columns', columns.join(','));
    setSelectedColumns(columnsString);
  };

  const isSelected = (columnName) => {
    const columns = selectedColumns.split(',');
    return columns.includes(columnName);
  };

  return (
    <Popover
      position={Position.BOTTOM_RIGHT}
      content={(
        <Menu>
          <Menu.Group>
            <Menu.Option onSelect={() => handleSelect('title')} isSelected={isSelected('title')}>Title</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('status')} isSelected={isSelected('status')}>Status</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('type')} isSelected={isSelected('type')}>Ticket type</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('created_by')} isSelected={isSelected('created_by')}>Created by</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('updated_by')} isSelected={isSelected('updated_by')}>Updated by</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('created_at')} isSelected={isSelected('created_at')}>Creation date</Menu.Option>
            <Menu.Option onSelect={() => handleSelect('updated_at')} isSelected={isSelected('updated_at')}>Update date</Menu.Option>
          </Menu.Group>
        </Menu>
      )}>
      <Button
        iconBefore={ColumnLayoutIcon}
        iconAfter={ChevronDownIcon}
        marginRight={majorScale(1)}>
        Columns
      </Button>
    </Popover>
  );
};

ColumnsMenu.propTypes = {
  selectedColumns: PropTypes.string,
  setSelectedColumns: PropTypes.func.isRequired,
};

export default ColumnsMenu;
